// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mobile-navigation"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 2H19V22H5V2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 7L15 13L12 12.0625L9 13L12 7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 2H19V22H5V2Z","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M12 7L15 13L12 12.0625L9 13L12 7Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M12 18H12.0039V18.0039H12V18Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const MobileNavigationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-navigation',
    ref,
    icon: element,
  },
));

MobileNavigationIcon.displayName = 'MobileNavigationIcon';

export default MobileNavigationIcon;
